import { render, staticRenderFns } from "./RflForm.vue?vue&type=template&id=11fc5898&scoped=true"
import script from "./RflForm.vue?vue&type=script&lang=js"
export * from "./RflForm.vue?vue&type=script&lang=js"
import style0 from "./RflForm.vue?vue&type=style&index=0&id=11fc5898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fc5898",
  null
  
)

export default component.exports